/**
 * The DGI emisor go-live date, as a human reads it.
 *
 * Used by the portal dashboard banner. A TWIN lives at
 * apps/mobile/lib/emisorVigenciaDate.ts, because mobile does not take a
 * shared-utils dependency (see lib/businessDayOrdinal.ts for the convention) —
 * change both together. The tests live here.
 *
 * NEVER THROUGH `new Date()`. The value is a date-only string (YYYY-MM-DD);
 * `new Date("2026-10-31")` is parsed as UTC midnight, and every Uruguayan
 * browser sits at UTC-3, so formatting that instant locally renders
 * **30/10/2026** — the day before the tenant can actually invoice. A date with
 * no time of day has no business becoming an instant; it is split, not parsed.
 *
 * Returns null for anything that is not a well-formed date-only string, so the
 * caller falls back to generic copy rather than printing "NaN/NaN/NaN" at a
 * tenant waiting to be enabled.
 */
export function formatEmisorVigenciaDate(isoDate) {
    if (!isoDate)
        return null;
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDate.trim());
    if (!m)
        return null;
    const [, year, month, day] = m;
    // dd/MM/yyyy — the format DGI itself uses in the authorization mail, so the
    // banner and the mail the tenant may have in front of them agree.
    return `${day}/${month}/${year}`;
}
